import * as React from "react";

import { RobotoLinkHoverUnderline } from "@/shared/components";
import CopyToClipboardButton from "@/shared/components/CopyToClipboardButton";
import { FileRecord } from "@/shared/domain/files";
import { basename, dirname } from "@/shared/domain/files/filesystem";
import { Goto } from "@/shared/navigation";

interface FilePathProps {
  /** The currently viewed file */
  fileRecord: FileRecord;
}

/**
 * UI for displaying the file path
 */
export function FilePath({ fileRecord }: FilePathProps) {
  const [filenameHovering, setFilenameHovering] =
    React.useState<boolean>(false);

  return (
    <div
      className="flex gap-sm"
      title={fileRecord.relative_path}
      onMouseEnter={() => setFilenameHovering(true)}
      onMouseLeave={() => setFilenameHovering(false)}
    >
      <RobotoLinkHoverUnderline
        className="truncate"
        to={Goto.createAssociationRoute(
          fileRecord.association_id,
          dirname(fileRecord.relative_path),
        )}
      >
        {basename(fileRecord.relative_path)}
      </RobotoLinkHoverUnderline>

      <CopyToClipboardButton
        text={basename(fileRecord.relative_path)}
        sx={{
          fontSize: "0.95rem",
          opacity: filenameHovering ? 1 : 0,
          transition: "opacity 0.2s",
          flexShrink: 0,
        }}
      />
    </div>
  );
}
